export default __webpack_public_path__ + "static/media/blueblock.c5920bd3.webp";